<div class="general-information-container" class="container-fluid" [formGroup]="formGroup">
    <div class="check-list">
        <ol class="custom-list">
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>Are you being referred by any representatives in PIAS? </span>
                    </div>

                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox #generalInformation_1 [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_1')?.value === true"
                            (change)="onCheckboxChange1($event.checked, true,'generalInformation_1',1)">Yes</mat-checkbox>
                        <mat-checkbox #generalInformation_no1 [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_1')?.value === false"
                            (change)="onCheckboxChange1($event.checked, false,'generalInformation_1',1)">No</mat-checkbox>
                    </div>
                    @if(this.formGroup.controls['generalInformation_1'].value == true && generalInformation_1.checked){
                    <div>
                        <mat-label>If Yes, please state the representative’s name:</mat-label>
                        <input matInput formControlName="generalInformationyes_1" type="text" />
                        @if(this.formGroup.controls["generalInformationyes_1"].invalid
                        && (this.formGroup.controls["generalInformationyes_1"].touched)
                        ) {
                        <mat-error>
                            @if(this.formGroup.controls["generalInformationyes_1"].errors?.["required"]) {
                            <span class="field-required">{{message}}</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </div>
                    }@else if(this.formGroup.controls['generalInformation_1'].value == false &&
                    generalInformation_no1.checked) {
                    <mat-label>If No, please select one of the options below:</mat-label>
                    <div class="checkbox-container">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformationno_1')?.value === 'Career Fair'"
                            (change)="onCheckboxChange($event.checked, 'Career Fair','generalInformationno_1')">
                            Career Fair
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformationno_1')?.value === 'Job Portal'"
                            (change)="onCheckboxChange($event.checked, 'Job Portal','generalInformationno_1')">
                            Job Portal
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformationno_1')?.value === 'Company’s Website'"
                            (change)="onCheckboxChange($event.checked, 'Company’s Website','generalInformationno_1')">
                            Company’s Website
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformationno_1')?.value === 'Magazine'"
                            (change)="onCheckboxChange($event.checked, 'Magazine','generalInformationno_1')">
                            Magazine
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformationno_1')?.value === 'Newspaper'"
                            (change)="onCheckboxChange($event.checked, 'Newspaper','generalInformationno_1')">
                            Newspaper
                        </mat-checkbox>

                        <mat-checkbox #generalInformationno_1 [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformationno_1')?.value === 'Others'"
                            (change)="onCheckboxChange($event.checked, 'Others','generalInformationno_1')">
                            Others
                            @if(this.formGroup.controls['generalInformationno_1'].value === 'Others' &&
                            generalInformationno_1.checked){
                            <input matInput formControlName="generalInformationno_1_others" type="text" />
                            }
                            @if(this.formGroup.controls["generalInformationno_1_others"].invalid
                            && (this.formGroup.controls["generalInformationno_1_others"].touched)
                            ) {
                            <mat-error>
                                @if(this.formGroup.controls["generalInformationno_1_others"].errors?.["required"]) {
                                <span class="field-required">{{message}}</span>
                                }
                                @else {
                                <span></span>
                                }
                            </mat-error>
                            }
                        </mat-checkbox>
                        @if(this.formGroup.controls["generalInformationno_1"].invalid
                        && (this.formGroup.controls["generalInformationno_1"].touched)
                        ) {
                        <mat-error>
                            @if(this.formGroup.controls["generalInformationno_1"].errors?.["required"]) {
                            <span class="field-required">{{message}}</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </div>
                    }
                </div>
                @if(this.formGroup.controls["generalInformation_1"].invalid
                && (this.formGroup.controls["generalInformation_1"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["generalInformation_1"].errors?.["required"]) {
                    <span class="field-required">{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>Have you ever conducted any regulated activities under the Securities and Futures Act
                            and/or provided any financial advisory service(s) under the Financial Advisers Act? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox #generalInformation_2 [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_2')?.value === true"
                            (change)="onCheckboxChange1($event.checked, true,'generalInformation_2',2)">Yes</mat-checkbox>
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_2')?.value === false"
                            (change)="onCheckboxChange1($event.checked, false,'generalInformation_2',2)">No</mat-checkbox>
                    </div>
                    @if(this.formGroup.controls['generalInformation_2'].value == true && generalInformation_2.checked){
                    <div>
                        <mat-label>If Yes, please state your previous Representative Number:</mat-label>
                        <input matInput formControlName="generalInformationyestext_2" type="text" />
                        <mat-checkbox formControlName="generalInformationyes_2">Check this if you do
                            not have your Representative Number and you have conducted
                            the regulated activities prior to 26 November 2010.</mat-checkbox>
                        @if(this.formGroup.controls["generalInformationyestext_2"].invalid
                        && (this.formGroup.controls["generalInformationyestext_2"].touched)
                        ) {
                        <mat-error>
                            @if(this.formGroup.controls["generalInformationyestext_2"].errors?.["required"]) {
                            <span class="field-required">{{message}}</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </div>
                    }
                </div>
                @if(this.formGroup.controls["generalInformation_2"].invalid
                && (this.formGroup.controls["generalInformation_2"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["generalInformation_2"].errors?.["required"]) {
                    <span class="field-required">{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>Do you have any outstanding CPF MediSave liabilities with CPF Board? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox #generalInformation_3 [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_3')?.value === true"
                            (change)="onCheckboxChange1($event.checked, true,'generalInformation_3',3)">Yes</mat-checkbox>
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_3')?.value === false"
                            (change)="onCheckboxChange1($event.checked, false,'generalInformation_3',3)">No</mat-checkbox>
                    </div>
                    @if(this.formGroup.controls['generalInformation_3'].value == true && generalInformation_3.checked){
                    <div>
                        <mat-label>If Yes, please provide the following details:</mat-label>
                        <br>
                        <mat-label>What is the outstanding CPF MediSave amount? </mat-label>

                        <input matInput formControlName="generalInformationyestext_3" type="text" />
                        <br>
                        <mat-label>Any payment arrangement with CPF Board: </mat-label>
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformationyes_3')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'generalInformationno_3')">Yes</mat-checkbox>
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformationyes_3')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'generalInformationno_3')">No</mat-checkbox>
                        @if(this.formGroup.controls["generalInformationyestext_3"].invalid
                        && (this.formGroup.controls["generalInformationyestext_3"].touched)
                        ) {
                        <mat-error>
                            @if(this.formGroup.controls["generalInformationyestext_3"].errors?.["required"]) {
                            <span class="field-required">{{message}}</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </div>
                    }
                    @if(this.formGroup.controls["generalInformation_3"].invalid
                    && (this.formGroup.controls["generalInformation_3"].touched)
                    ) {
                    <mat-error>
                        @if(this.formGroup.controls["generalInformation_3"].errors?.["required"]) {
                        <span class="field-required">{{message}}</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                </div>
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>Will you be based overseas? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_4')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'generalInformation_4')">Yes</mat-checkbox>
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_4')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'generalInformation_4')">No</mat-checkbox>
                    </div>
                    @if(this.formGroup.controls["generalInformation_4"].invalid
                    && (this.formGroup.controls["generalInformation_4"].touched)
                    ) {
                    <mat-error>
                        @if(this.formGroup.controls["generalInformation_4"].errors?.["required"]) {
                        <span class="field-required">{{message}}</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                </div>
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>Have you ever executed a deed poll, whether in Singapore or elsewhere?
                            (If Yes, please provide a copy of the deed poll) </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox #generalInformation_5 [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_5')?.value === true"
                            (change)="onCheckboxChange1($event.checked, true,'generalInformation_5',5)">Yes</mat-checkbox>
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_5')?.value === false"
                            (change)="onCheckboxChange1($event.checked, false,'generalInformation_5',5)">No</mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls['generalInformation_5'].value == true && generalInformation_5.checked){
                <div class="col-sm-6 col-md-6 col-lg-6 col-xxl-6 m-0">
                    <mat-label class="field-label">Attachment (copy of the deed poll)</mat-label>
                    <div class="upload-container">
                        <div class="upload-box">
                            <input type="file" id="generalInformationyes_5" [disabled]="readonly()"
                                accept=".pdf,.jpg,.jpeg,.png"
                                (change)="onAttachmentFileChange($event,'generalInformationyes_5','generalInformationyes_5file','generalInformation_5')">
                            <input type="text" formControlName="generalInformationyes_5" hidden>

                            <!-- Show filename OR placeholder -->
                            @if(!this.formGroup.get('generalInformationyes_5')?.value){
                            <span>
                                Choose a file
                            </span>
                            }
                            @if(this.formGroup.get('generalInformationyes_5')?.value){
                            <div class="attachment-row">
                                <span class="file-name">
                                    {{ this.formGroup.get('generalInformationyes_5')?.value }}
                                </span>
                                @if(readonly() === false){
                                <button mat-icon-button color="primary" class="delete-btn"
                                (click)="removeFile('generalInformationyes_5','generalInformationyes_5file','generalInformation_5')">
                                <mat-icon>close</mat-icon>
                                </button>
                                }
                                <button mat-icon-button color="primary" class="delete-btn"
                                (click)="previewAttachment('generalInformationyes_5','generalInformation_5')">
                                <mat-icon>visibility</mat-icon>
                                </button>               
                            </div>
                            }
                        </div>
                    </div>
                    @if(this.formGroup.controls["generalInformationyes_5"]?.invalid
                    && (this.formGroup.controls["generalInformationyes_5"].touched )
                    ) {
                    <mat-error>
                        @if(this.formGroup.controls["generalInformationyes_5"].errors?.["required"]) {
                        <span class="field-required">{{message}}</span>
                        }@else if(this.formGroup.controls["generalInformationyes_5"].errors?.['invalidType']){
                        <span>Only PDF, JPG, PNG files are allowed.</span>
                        }
                        @else if(this.formGroup.controls["generalInformationyes_5"].errors?.['maxSize']){
                        <span>File size must be less than or equal to 5MB.</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                </div>
                }
                @if(this.formGroup.controls["generalInformation_5"].invalid
                && (this.formGroup.controls["generalInformation_5"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["generalInformation_5"].errors?.["required"]) {
                    <span class="field-required">{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>Will you be applying for any financing scheme in PIAS? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox #generalInformation_6 [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_6')?.value === true"
                            (change)="onCheckboxChange1($event.checked, true,'generalInformation_6',6)">Yes</mat-checkbox>
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_6')?.value === false"
                            (change)="onCheckboxChange1($event.checked, false,'generalInformation_6',6)">No</mat-checkbox>
                    </div>
                    @if(this.formGroup.controls['generalInformation_6'].value == true && generalInformation_6.checked){
                    <div>
                        <mat-label>If Yes, please specify name of scheme:</mat-label>
                        <input matInput formControlName="generalInformationyes_6" type="text" />
                        @if(this.formGroup.controls["generalInformationyes_6"].invalid
                        && (this.formGroup.controls["generalInformationyes_6"].touched)
                        ) {
                        <mat-error>
                            @if(this.formGroup.controls["generalInformationyes_6"].errors?.["required"]) {
                            <span class="field-required">{{message}}</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </div>
                    }
                </div>
                @if(this.formGroup.controls["generalInformation_6"].invalid
                && (this.formGroup.controls["generalInformation_6"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["generalInformation_6"].errors?.["required"]) {
                    <span class="field-required">{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <mat-label class="sub-header">Non-Financial Advisory Activities</mat-label>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>Are you currently engaged with other gainful employment? </span>
                        <span class="fw-bold">(If Yes, please provide an approval letter from your employer(s) in
                            disclosing your
                            representative status with PIAS.)</span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox #generalInformation_7 [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_7')?.value === true"
                            (change)="onCheckboxChange1($event.checked, true,'generalInformation_7',7)">Yes</mat-checkbox>
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_7')?.value === false"
                            (change)="onCheckboxChange1($event.checked, false,'generalInformation_7',7)">No</mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls['generalInformation_7'].value == true && generalInformation_7.checked){
                <div class="col-sm-6 col-md-6 col-lg-6 col-xxl-6 m-0">
                    <mat-label class="field-label">Attachment (Employer consent form)
                        @if(readonly() === false){
                        <span class="download-btn" (click)="downloadForm()">Download Forms</span>
                        }
                    </mat-label>
                    <div class="upload-container">
                        <div class="upload-box">
                            <input type="file" id="generalInformationyes_7" [disabled]="readonly()"
                                accept=".pdf,.jpg,.jpeg,.png"
                                (change)="onAttachmentFileChange($event,'generalInformationyes_7','generalInformationyes_7file','generalInformation_7')">
                            <input type="text" formControlName="generalInformationyes_7" hidden>
                            <!-- Show filename OR placeholder -->
                            @if(!this.formGroup.get('generalInformationyes_7')?.value){
                            <span>
                                Choose a file
                            </span>
                            }
                            @if(this.formGroup.get('generalInformationyes_7')?.value){
                            <div class="attachment-row">
                                <span class="file-name">
                                    {{ this.formGroup.get('generalInformationyes_7')?.value }}
                                </span>
                                @if(readonly() === false){
                                <button mat-icon-button color="primary" class="delete-btn"
                                (click)="removeFile('generalInformationyes_7','generalInformationyes_7file','generalInformation_7')">
                                <mat-icon>close</mat-icon>
                                </button>
                                }
                                <button mat-icon-button color="primary" class="delete-btn"
                                (click)="previewAttachment('generalInformationyes_7','generalInformation_7')">
                                <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                            }
                        </div>
                    </div>
                    @if(this.formGroup.controls["generalInformationyes_7"]?.invalid
                    && (this.formGroup.controls["generalInformationyes_7"].touched )
                    ) {
                    <mat-error>
                        @if(this.formGroup.controls["generalInformationyes_7"].errors?.["required"]) {
                        <span class="field-required">{{message}}</span>
                        }
                        @else if(this.formGroup.controls["generalInformationyes_7"].errors?.['invalidType']){
                        <span>Only PDF, JPG, PNG files are allowed.</span>
                        }
                        @else if(this.formGroup.controls["generalInformationyes_7"].errors?.['maxSize']){
                        <span>File size must be less than or equal to 5MB.</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                </div>
                }
                @if(this.formGroup.controls["generalInformation_7"].invalid
                && (this.formGroup.controls["generalInformation_7"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["generalInformation_7"].errors?.["required"]) {
                    <span class="field-required">{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>Is any of your connected persons currently engaged in any gainful employment (e.g.
                            Contracting, Freelance, Consultancy work, Political position or Second job) which has
                            business activities with PIAS? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_8')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'generalInformation_8')">Yes</mat-checkbox>
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_8')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'generalInformation_8')">No</mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["generalInformation_8"].invalid
                && (this.formGroup.controls["generalInformation_8"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["generalInformation_8"].errors?.["required"]) {
                    <span class="field-required">{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>

            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>Is any of your connected persons currently working in PIAS?</span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox #generalInformation_9 [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_9')?.value === true"
                            (change)="onCheckboxChange1($event.checked, true,'generalInformation_9',9)">Yes</mat-checkbox>
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_9')?.value === false"
                            (change)="onCheckboxChange1($event.checked, false,'generalInformation_9',9)">No</mat-checkbox>
                    </div>
                    @if(this.formGroup.controls['generalInformation_9'].value == true && generalInformation_9.checked){
                    <div class="row g-3">

                        <!-- connected person Name -->
                        <div class="col-md-6">
                            <mat-label class="field-label">Connected Person Name</mat-label>
                            <mat-form-field class="w-100 custom-form-field">
                                <input matInput formControlName="connectedpersonname"
                                    placeholder="Enter Connected Person Name" required>
                                @if(this.formGroup.controls["connectedpersonname"].invalid
                                && (this.formGroup.controls["connectedpersonname"].touched ||
                                this.formGroup.controls["connectedpersonname"].dirty)
                                ) {
                                <mat-error>
                                    @if(this.formGroup.controls["connectedpersonname"].errors?.["required"]) {
                                    <span class="field-required">{{message}}</span>
                                    }
                                    @else {
                                    <span></span>
                                    }
                                </mat-error>
                                }
                            </mat-form-field>
                        </div>

                        <!-- Preferred Name -->
                        <div class="col-md-6">
                            <mat-label class="field-label">Relationship</mat-label>
                            <mat-form-field class="w-100 custom-form-field">
                                <input matInput formControlName="relationship" placeholder="Enter Relationship "
                                    required>
                                @if(this.formGroup.controls["relationship"].invalid
                                && (this.formGroup.controls["relationship"].touched ||
                                this.formGroup.controls["relationship"].dirty)
                                ) {
                                <mat-error>
                                    @if(this.formGroup.controls["relationship"].errors?.["required"]) {
                                    <span class="field-required">{{message}}</span>
                                    }
                                    @else {
                                    <span></span>
                                    }
                                </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </div>
                    }
                </div>
                @if(this.formGroup.controls["generalInformation_9"].invalid
                && (this.formGroup.controls["generalInformation_9"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["generalInformation_9"].errors?.["required"]) {
                    <span class="field-required">{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>Are you currently holding or intend to hold a moneylender’s licence or being an employee,
                            director, shareholder, sole proprietor or partner of a licensed moneylender?
                        </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_10')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'generalInformation_10')">Yes</mat-checkbox>
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_10')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'generalInformation_10')">No</mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["generalInformation_10"].invalid
                && (this.formGroup.controls["generalInformation_10"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["generalInformation_10"].errors?.["required"]) {
                    <span class="field-required">{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>Are you currently holding or intend to hold a junket promoter licence or being an
                            employee,
                            director, shareholder, sole proprietor, partner or associate of a licensed junket promoter?
                        </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_11')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'generalInformation_11')">Yes</mat-checkbox>
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_11')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'generalInformation_11')">No</mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["generalInformation_11"].invalid
                && (this.formGroup.controls["generalInformation_11"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["generalInformation_11"].errors?.["required"]) {
                    <span class="field-required">{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>Are you currently acting or intend to act as a real estate salesperson or agent, or being
                            an
                            employee, director, shareholder, sole‐proprietor or partner of a licensed estate
                            agency?</span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_12')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'generalInformation_12')">Yes</mat-checkbox>
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_12')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'generalInformation_12')">No</mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["generalInformation_12"].invalid
                && (this.formGroup.controls["generalInformation_12"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["generalInformation_12"].errors?.["required"]) {
                    <span class="field-required">{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>Are you currently marketing or intend to market products/investments not regulated under
                            the Financial Advisers Act?
                        </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_13')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'generalInformation_13')">Yes</mat-checkbox>
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('generalInformation_13')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'generalInformation_13')">No</mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["generalInformation_13"].invalid
                && (this.formGroup.controls["generalInformation_13"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["generalInformation_13"].errors?.["required"]) {
                    <span class="field-required">{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
        </ol>


    </div>
    @if(readonly() === false){

    @if(isVisible() === true){
    <div class="editor-actions">
        <button mat-stroked-button type="button" (click)="cancelSection()">Cancel</button>
        <button type="button" class="save-btn" (click)="saveSection()">
            <mat-icon>save</mat-icon>Save</button>
    </div>
    }@else{
    <!-- Form Actions -->
    <div class="form-actions">

        <button mat-raised-button class="save-btn" (click)="saveAndContinue()">

            <span>Save & Continue</span>
            <mat-icon>arrow_forward</mat-icon>

        </button>

    </div>
    }
    }
</div>